import Pusher from 'pusher-js';
import {PUSHER_APP_KEY, PUSHER_APP_CLUSTER} from '../constants/pusher';
import store from '../store/configureStore';

export const pusherClient = () => {
  const pusher = new Pusher(PUSHER_APP_KEY, {
    cluster: PUSHER_APP_CLUSTER,
    encrypted: true
  });

  return pusher;
};

export const statusChannelName = (socketId = store.getState().pusher.socketId) => {
  return `API_RESPONSE_${socketId}`;
};


// WEBPACK FOOTER //
// ./src/utils/pusher.js